// extracted by mini-css-extract-plugin
export default {"Label":"SelectWithLabel_Label__ZQKwp","Error":"SelectWithLabel_Error__FBxqN"};